import React, { createContext, useContext, useState, useEffect } from 'react';

const RoleContext = createContext(null);

export function RoleProvider({ children }) {
  const [role, setRole] = useState(() => {
    try { return localStorage.getItem('gd_role') || 'default'; } catch { return 'default'; }
  });
  useEffect(() => { try { localStorage.setItem('gd_role', role); } catch {} }, [role]);
  return <RoleContext.Provider value={{ role, setRole }}>{children}</RoleContext.Provider>;
}

export function useRole() { return useContext(RoleContext) || { role: 'default', setRole: () => {} }; }
